import styled from '@emotion/styled'
import React, { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { colors } from '@/styles/theme'
import { ColorSelector } from '@/components/atoms/ColorSelector'
import { SexSelector } from '@/components/atoms/SexSelector'
import { VoiceChatSelector } from '@/components/atoms/VoiceChatSelector'
import {
  InputText,
  InputSelector,
  OptionsPlaytime,
} from '@/components/atoms/Inputs'
import { VoiceChat } from '@/firebase/firestore/VoiceChats'
import { Platform } from '@/firebase/firestore/Platform'
import { Sex } from '@/firebase/firestore/Sex'
import { useLocale } from '@/hooks/useLocale'
import { ImageSelector } from '@/components/atoms/ImageSelector'
import { TextSelector } from '@/components/atoms/TextSelector'
import { TemplateSelector } from '@/components/atoms/TemplateSelector'
import { Splatoon3_1 } from './Splatoon3_1'
import { Splatoon3_2 } from './Splatoon3_2'
import { Splatoon3_3 } from './Splatoon3_3'
import { Splatoon3_4 } from './Splatoon3_4'
import { Splatoon3_5 } from './Splatoon3_5'
import { Splatoon3_6 } from './Splatoon3_6'
import { Splatoon3_7 } from './Splatoon3_7'
import { ProfileCardEditorDescription } from '@/components/atoms/ProfileCardEditorDescription'
import {
  CREATOR,
  creatorMapTargetId,
  CREATORS,
  mapPSplatoon3CreatorInfo,
} from './config'
import { format } from 'date-fns'
import Image from 'next/image'
import { ProfileEditorAppBanner } from '../../Banner/ProfileEditorAppBanner'

/**
 * プラットフォーム事にフォームが違う
 *
 */

type FormField = {
  name: string
  id: string
  playStyle: string
  playTimeWeekDayBegin: string
  playTimeWeekDayEnd: string
  playTimeWeekEndBegin: string
  playTimeWeekEndEnd: string
  team: string
  fes: string
  rank: number
  favoriteRules: number[]
  favoriteCharTypes: number[]
  udemae: string
  baito: string
  asari: string
  yagura: string
  hoko: string
  area: string
  salmonRun: string
  favoriteWeapon: string
  voiceChatFree: string
  hitokoto: string
}

type Props = {
  onCreate: (
    data: FormField & { selectedRules: number[] },
    targetId: string,
    selectedSex: Sex,
    selectedPlatform: Array<Platform>,
    selectedVoiceChat: Array<VoiceChat>
  ) => void
  submitButtonDisable: boolean
  creatorParam: string | null
}

const FONT_COLORS = [
  '#FD8080',
  '#FD7C24',
  '#29DDF2',
  '#C05AE0',
  '#7AA852',
  '#4C4C4C',
  '#F8F1E7',
]

const FONT_FAMILIES = [
  {
    imagePath: '/static/images/fonts/ap.png',
    value: 'ap',
  },
  {
    imagePath: '/static/images/fonts/anko.png',
    value: 'anko',
  },
  {
    imagePath: '/static/images/fonts/smart_ui.png',
    value: 'smartfont',
  },
  {
    imagePath: '/static/images/fonts/noto_sans.png',
    value: 'notosans',
  },
] as const

type FONT_FAMILY = (typeof FONT_FAMILIES)[number]['value']

const SPLATOON_RULES: Record<CREATOR, any[]> = {
  koharubiyori_51: [
    {
      displayName: 'ナワバリ',
      value: 'nawabari',
    },
    {
      displayName: 'プラベ',
      value: 'purabe',
    },
    {
      displayName: 'リグマ',
      value: 'riguma',
    },
    {
      displayName: 'バイト',
      value: 'baito',
    },
    {
      displayName: 'エリア',
      value: 'area',
    },
    {
      displayName: 'ヤグラ',
      value: 'yagura',
    },
    {
      displayName: 'ホコ',
      value: 'hoko',
    },
    {
      displayName: 'アサリ',
      value: 'asari',
    },
    {
      displayName: 'サモラン',
      value: 'salmonRun',
    },
  ],
  sakiika10_game: [
    {
      displayName: 'ナワバリ',
      value: 'nawabari',
    },
    {
      displayName: 'プラベ',
      value: 'purabe',
    },
    {
      displayName: 'リグマ',
      value: 'riguma',
    },
    {
      displayName: 'バイト',
      value: 'baito',
    },
    {
      displayName: 'エリア',
      value: 'area',
    },
    {
      displayName: 'ヤグラ',
      value: 'yagura',
    },
    {
      displayName: 'ホコ',
      value: 'hoko',
    },
    {
      displayName: 'アサリ',
      value: 'asari',
    },
    {
      displayName: 'サモラン',
      value: 'salmonRun',
    },
  ],
  MHR_Qoo: [
    {
      displayName: 'ナワバリ',
      value: 'nawabari',
    },
    {
      displayName: 'プラベ',
      value: 'purabe',
    },
    {
      displayName: 'リグマ',
      value: 'riguma',
    },
    {
      displayName: 'バイト',
      value: 'baito',
    },
    {
      displayName: 'エリア',
      value: 'area',
    },
    {
      displayName: 'ヤグラ',
      value: 'yagura',
    },
    {
      displayName: 'ホコ',
      value: 'hoko',
    },
    {
      displayName: 'アサリ',
      value: 'asari',
    },
    {
      displayName: 'サモラン',
      value: 'salmonRun',
    },
  ],
  ibless0316: [
    {
      displayName: 'ナワバリ',
      value: 'nawabari',
    },
    {
      displayName: 'エリア',
      value: 'area',
    },
    {
      displayName: 'ヤグラ',
      value: 'yagura',
    },
    {
      displayName: 'トリカラ',
      value: 'torikara',
    },
    {
      displayName: 'Xマッチ',
      value: 'crossMatch',
    },
    {
      displayName: 'アサリ',
      value: 'asari',
    },
    {
      displayName: 'プラベ',
      value: 'purabe',
    },
    {
      displayName: 'ホコ',
      value: 'hoko',
    },
    {
      displayName: 'サモラン',
      value: 'salmonRun',
    },
    {
      displayName: 'リグマ',
      value: 'riguma',
    },
  ],
  MHR_Qoo_2: [
    {
      displayName: 'ナワバリ',
      value: 'nawabari',
    },
    {
      displayName: 'プラベ',
      value: 'purabe',
    },
    {
      displayName: 'リグマ',
      value: 'riguma',
    },
    {
      displayName: 'バイト',
      value: 'baito',
    },
    {
      displayName: 'エリア',
      value: 'area',
    },
    {
      displayName: 'ヤグラ',
      value: 'yagura',
    },
    {
      displayName: 'ホコ',
      value: 'hoko',
    },
    {
      displayName: 'アサリ',
      value: 'asari',
    },
    {
      displayName: 'サモラン',
      value: 'salmonRun',
    },
  ],
  _pira__: [
    {
      displayName: 'ホコ',
      value: 'hoko',
    },
    {
      displayName: 'ヤグラ',
      value: 'yagura',
    },
    {
      displayName: 'エリア',
      value: 'area',
    },
    {
      displayName: 'アサリ',
      value: 'asari',
    },
    {
      displayName: 'バイト',
      value: 'baito',
    },
    {
      displayName: 'ナワバリ',
      value: 'nawabari',
    },
  ],
  MHR_Qoo_3: [
    {
      displayName: 'ナワバリ',
      value: 'nawabari',
    },
    {
      displayName: 'プラベ',
      value: 'purabe',
    },
    {
      displayName: 'リグマ',
      value: 'riguma',
    },
    {
      displayName: 'バイト',
      value: 'baito',
    },
    {
      displayName: 'エリア',
      value: 'area',
    },
    {
      displayName: 'ヤグラ',
      value: 'yagura',
    },
    {
      displayName: 'ホコ',
      value: 'hoko',
    },
    {
      displayName: 'アサリ',
      value: 'asari',
    },
    {
      displayName: 'サモラン',
      value: 'salmonRun',
    },
  ],
}

const SPLATOON_CHAR_TYPES = [
  {
    displayName: 'イカ派',
    value: 'ika',
  },
  {
    displayName: 'タコ派',
    value: 'tako',
  },
] as const

const creatorMapColors: Record<CREATOR, string[]> = {
  koharubiyori_51: ['#F7928F', '#FFF87A', '#BDA0F7', '#545454'],
  sakiika10_game: [
    '#FED4BC',
    '#DFFED4',
    '#FFCDD0',
    '#CDF7FE',
    '#FED4BC',
    '#DFFED4',
    '#FFCDD0',
    '#CDF7FE',
    '#FED4BC',
    '#DFFED4',
    '#FFCDD0',
    '#CDF7FE',
  ],
  MHR_Qoo: [
    '#FEA0AC',
    '#FEC46E',
    '#FFFFA1',
    '#93F4A3',
    '#84E1F9',
    '#4757E7',
    '#A081E9',
    '#AD6C36',
    '#636363',
  ],
  ibless0316: [
    '#9F0000',
    '#B8538C',
    '#996936',
    '#FF6F47',
    '#727272',
    '#475C69',
    '#595F5B',
    '#A78D81',
  ],
  MHR_Qoo_2: [
    '#FECBD4',
    '#AAC3E9',
    '#E2B1DF',
    '#D8D8D8',
    '#F7B3C0',
    '#C18BBD',
    '#A7E393',
    '#899389',
    '#FEB95F',
  ],
  _pira__: ['#F4EFDA', '#CBDBEB', '#D8D8D8'],
  MHR_Qoo_3: [
    '#636363',
    '#F06989',
    '#FFABC8',
    '#FFBE8B',
    '#FFEA9C',
    '#A1D578',
    '#4C9254',
    '#96E4EC',
    '#739CDE',
    '#D997FB',
    '#A8A8A8',
    '#FAF596',
    '#3B5377',
    '#20763C',
    '#C3504B',
  ],
}

const templates = Object.keys(mapPSplatoon3CreatorInfo).map((creatorName) => {
  return {
    imagePath: mapPSplatoon3CreatorInfo[creatorName]['profileCardImageURL'],
    value: creatorName,
  }
})

export const EditorSplatoon3: React.FC<Props> = ({
  onCreate,
  submitButtonDisable,
  creatorParam,
}) => {
  const { t } = useLocale()
  const { handleSubmit, register, watch } = useForm<FormField>({
    defaultValues: {
      playTimeWeekDayBegin: '18',
      playTimeWeekDayEnd: '20',
      playTimeWeekEndBegin: '18',
      playTimeWeekEndEnd: '20',
    },
  })
  const fieldVal = watch()

  const [selectedCreator, setSelectedCreator] = useState<CREATOR>(
    CREATORS.includes(creatorParam as any)
      ? (creatorParam as CREATOR)
      : CREATORS[0]
  )
  useEffect(() => {
    if (!selectedCreator) return
    const url = new URL(window.location.href)
    url.searchParams.set('creator', selectedCreator)
    window.history.pushState(null, '', url.toString())
  }, [selectedCreator])

  const [selectedFontFamily, setSelectedFontFamily] =
    useState<FONT_FAMILY>('ap')
  const [selectedColor, setColor] = useState(0)
  const onChangeColor = useCallback((selectedIndex: number) => {
    setColor(selectedIndex)
  }, [])
  const [selectedFontColor, setFontColor] = useState(0)
  const onChangeFontColor = useCallback((selectedIndex: number) => {
    setFontColor(selectedIndex)
  }, [])
  const [selectedSex, setSex] = useState<Sex>(0)
  const onChangeSex = useCallback((selectedIndex: Sex) => {
    setSex(selectedIndex)
  }, [])

  const selectedPlatform: Platform[] = [0]

  const [selectedVoiceChat, setVoiceChat] = useState<Array<VoiceChat>>([])
  const onChangeVoiceChat = useCallback((selectedIndex: Array<VoiceChat>) => {
    setVoiceChat(selectedIndex)
  }, [])
  const [selectedCharTypes, setChars] = useState<number[]>([])
  const onChangeChars = useCallback((selectedIndex: number[]) => {
    setChars(selectedIndex)
  }, [])
  const [selectedRules, setRules] = useState<number[]>([])
  const onChangeRules = useCallback((selectedIndex: number[]) => {
    setRules(selectedIndex)
  }, [])

  const [preview, setPreview] = useState<string | null>(null)

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          setPreview(reader.result)
        }
      }
      reader.readAsDataURL(file)
    }
  }

  const handleCreate = (data: FormField) => {
    onCreate(
      { ...data, selectedRules },
      creatorMapTargetId[selectedCreator],
      selectedSex,
      selectedPlatform,
      selectedVoiceChat
    )
  }

  const lastModText = format(new Date(), 'yyyy年MM月dd日')

  return (
    <>
      <Image
        width="1920"
        height="1080"
        priority={true}
        unoptimized={true}
        src={`/static/images/promotes/splatoon3.jpg`}
        alt={`スプラ自己紹介カード作成ツール`}
      />
      <DescriptionSection>
        <Time>
          <time dateTime={new Date().toISOString()} itemProp="datepublished" />
          <time dateTime={new Date().toISOString()} itemProp="modified">
            {t.最終更新}: {lastModText}
          </time>
        </Time>
        <H1Text>{t.Splatoon3かわいい自己紹介カード作成ツール}</H1Text>
        <H2Text>{t.Splatoon3かわいい自己紹介カード作成ツール説明文}</H2Text>
        <ProfileCardEditorDescription />
      </DescriptionSection>
      <PreviewContainer>
        <PreviewCardContainer>
          {selectedCreator === 'koharubiyori_51' && (
            <Splatoon3_1
              targetId={creatorMapTargetId[selectedCreator]}
              fontColor={FONT_COLORS[selectedFontColor]}
              fontFamily={selectedFontFamily}
              playStyle={fieldVal.playStyle}
              platform={selectedPlatform}
              name={fieldVal.name}
              id={fieldVal.id}
              sex={selectedSex}
              templateColor={selectedColor as 0 | 1 | 2 | 3}
              voiceChat={selectedVoiceChat}
              playTimeWeekDayBegin={fieldVal.playTimeWeekDayBegin}
              playTimeWeekDayEnd={fieldVal.playTimeWeekDayEnd}
              playTimeWeekEndBegin={fieldVal.playTimeWeekEndBegin}
              playTimeWeekEndEnd={fieldVal.playTimeWeekEndEnd}
              team={fieldVal.team}
              rank={fieldVal.rank}
              asari={fieldVal.asari}
              yagura={fieldVal.yagura}
              hoko={fieldVal.hoko}
              area={fieldVal.area}
              favoriteWeapon={fieldVal.favoriteWeapon}
              hitokoto={fieldVal.hitokoto}
            />
          )}
          {selectedCreator === 'sakiika10_game' && (
            <Splatoon3_2
              targetId={creatorMapTargetId[selectedCreator]}
              fontColor={FONT_COLORS[selectedFontColor]}
              fontFamily={selectedFontFamily}
              playStyle={fieldVal.playStyle}
              platform={selectedPlatform}
              name={fieldVal.name}
              id={fieldVal.id}
              sex={selectedSex}
              templateColor={selectedColor as 0 | 1 | 2 | 3}
              voiceChat={selectedVoiceChat}
              voiceChatFree={fieldVal.voiceChatFree}
              playTimeWeekDayBegin={fieldVal.playTimeWeekDayBegin}
              playTimeWeekDayEnd={fieldVal.playTimeWeekDayEnd}
              playTimeWeekEndBegin={fieldVal.playTimeWeekEndBegin}
              playTimeWeekEndEnd={fieldVal.playTimeWeekEndEnd}
              team={fieldVal.team}
              rank={fieldVal.rank}
              rules={selectedRules}
              asari={fieldVal.asari}
              yagura={fieldVal.yagura}
              hoko={fieldVal.hoko}
              area={fieldVal.area}
              favoriteWeapon={fieldVal.favoriteWeapon}
              hitokoto={fieldVal.hitokoto}
            />
          )}
          {selectedCreator === 'MHR_Qoo' && (
            <Splatoon3_3
              targetId={creatorMapTargetId[selectedCreator]}
              fontColor={FONT_COLORS[selectedFontColor]}
              fontFamily={selectedFontFamily}
              playStyle={fieldVal.playStyle}
              platform={selectedPlatform}
              name={fieldVal.name}
              id={fieldVal.id}
              sex={selectedSex}
              templateColor={selectedColor as 0 | 1 | 2 | 3}
              voiceChat={selectedVoiceChat}
              playTimeWeekDayBegin={fieldVal.playTimeWeekDayBegin}
              playTimeWeekDayEnd={fieldVal.playTimeWeekDayEnd}
              playTimeWeekEndBegin={fieldVal.playTimeWeekEndBegin}
              playTimeWeekEndEnd={fieldVal.playTimeWeekEndEnd}
              fes={fieldVal.fes}
              rank={fieldVal.rank}
              characterTypes={selectedCharTypes}
              rules={selectedRules}
              asari={fieldVal.asari}
              yagura={fieldVal.yagura}
              hoko={fieldVal.hoko}
              area={fieldVal.area}
              favoriteWeapon={fieldVal.favoriteWeapon}
              hitokoto={fieldVal.hitokoto}
            />
          )}
          {selectedCreator === 'ibless0316' && (
            <Splatoon3_4
              targetId={creatorMapTargetId[selectedCreator]}
              fontColor={FONT_COLORS[selectedFontColor]}
              fontFamily={selectedFontFamily}
              platform={selectedPlatform}
              name={fieldVal.name}
              id={fieldVal.id}
              sex={selectedSex}
              templateColor={selectedColor as 0 | 1 | 2 | 3}
              voiceChat={selectedVoiceChat}
              playTimeWeekDayBegin={fieldVal.playTimeWeekDayBegin}
              playTimeWeekDayEnd={fieldVal.playTimeWeekDayEnd}
              playTimeWeekEndBegin={fieldVal.playTimeWeekEndBegin}
              playTimeWeekEndEnd={fieldVal.playTimeWeekEndEnd}
              playStyle={fieldVal.playStyle}
              team={fieldVal.team}
              rank={fieldVal.rank}
              characterTypes={selectedCharTypes}
              rules={selectedRules}
              asari={fieldVal.asari}
              yagura={fieldVal.yagura}
              hoko={fieldVal.hoko}
              area={fieldVal.area}
              salmonRun={fieldVal.salmonRun}
              favoriteWeapon={fieldVal.favoriteWeapon}
              hitokoto={fieldVal.hitokoto}
            />
          )}
          {selectedCreator === 'MHR_Qoo_2' && (
            <Splatoon3_5
              targetId={creatorMapTargetId[selectedCreator]}
              fontColor={FONT_COLORS[selectedFontColor]}
              fontFamily={selectedFontFamily}
              playStyle={fieldVal.playStyle}
              platform={selectedPlatform}
              name={fieldVal.name}
              id={fieldVal.id}
              sex={selectedSex}
              templateColor={selectedColor as 0 | 1 | 2 | 3}
              voiceChat={selectedVoiceChat}
              playTimeWeekDayBegin={fieldVal.playTimeWeekDayBegin}
              playTimeWeekDayEnd={fieldVal.playTimeWeekDayEnd}
              playTimeWeekEndBegin={fieldVal.playTimeWeekEndBegin}
              playTimeWeekEndEnd={fieldVal.playTimeWeekEndEnd}
              fes={fieldVal.fes}
              rank={fieldVal.rank}
              characterTypes={selectedCharTypes}
              rules={selectedRules}
              udemae={fieldVal.udemae}
              favoriteWeapon={fieldVal.favoriteWeapon}
              hitokoto={fieldVal.hitokoto}
            />
          )}
          {selectedCreator === '_pira__' && (
            <Splatoon3_6
              targetId={creatorMapTargetId[selectedCreator]}
              previewImage={preview ?? ''}
              fontColor={FONT_COLORS[selectedFontColor]}
              fontFamily={selectedFontFamily}
              playStyle={fieldVal.playStyle}
              platform={selectedPlatform}
              name={fieldVal.name}
              id={fieldVal.id}
              sex={selectedSex}
              templateColor={selectedColor as 0 | 1 | 2 | 3}
              voiceChat={selectedVoiceChat}
              playTimeWeekDayBegin={fieldVal.playTimeWeekDayBegin}
              playTimeWeekDayEnd={fieldVal.playTimeWeekDayEnd}
              playTimeWeekEndBegin={fieldVal.playTimeWeekEndBegin}
              playTimeWeekEndEnd={fieldVal.playTimeWeekEndEnd}
              rank={fieldVal.rank}
              rules={selectedRules}
              udemae={fieldVal.udemae}
              baito={fieldVal.baito}
              favoriteWeapon={fieldVal.favoriteWeapon}
              hitokoto={fieldVal.hitokoto}
            />
          )}
          {selectedCreator === 'MHR_Qoo_3' && (
            <Splatoon3_7
              targetId={creatorMapTargetId[selectedCreator]}
              fontColor={FONT_COLORS[selectedFontColor]}
              fontFamily={selectedFontFamily}
              playStyle={fieldVal.playStyle}
              platform={selectedPlatform}
              name={fieldVal.name}
              id={fieldVal.id}
              sex={selectedSex}
              templateColor={selectedColor as 0 | 1 | 2 | 3}
              voiceChat={selectedVoiceChat}
              playTimeWeekDayBegin={fieldVal.playTimeWeekDayBegin}
              playTimeWeekDayEnd={fieldVal.playTimeWeekDayEnd}
              playTimeWeekEndBegin={fieldVal.playTimeWeekEndBegin}
              playTimeWeekEndEnd={fieldVal.playTimeWeekEndEnd}
              rules={selectedRules}
              udemae={fieldVal.udemae}
              favoriteWeapon={fieldVal.favoriteWeapon}
              hitokoto={fieldVal.hitokoto}
            />
          )}
        </PreviewCardContainer>
        <ProfileEditorAppBanner game="splatoon3" />
      </PreviewContainer>
      <FormContainer>
        <form
          onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
          onSubmit={handleSubmit(handleCreate)}
        >
          <FormItemContainer>
            <SectionHeader>{t.テンプレートを選ぶ}</SectionHeader>
            <TemplateSelector
              values={templates}
              onChange={setSelectedCreator as any}
              value={selectedCreator}
            />
          </FormItemContainer>
          <FormItemContainer>
            <SectionHeader>{t.カードの背景色を選ぶ}</SectionHeader>
            <ColorSelector
              // templateで可変
              colors={creatorMapColors[selectedCreator]}
              value={selectedColor}
              onChange={onChangeColor}
            />
          </FormItemContainer>
          <FormItemContainer>
            <SectionHeader>{t.文字色を選ぶ}</SectionHeader>
            <ColorSelector
              colors={FONT_COLORS}
              value={selectedFontColor}
              onChange={onChangeFontColor}
            />
          </FormItemContainer>
          <FormItemContainer>
            <SectionHeader>{t.フォントを選ぶ}</SectionHeader>
            <ImageSelector
              values={FONT_FAMILIES}
              onChange={setSelectedFontFamily as any}
              value={selectedFontFamily}
            />
          </FormItemContainer>
          {selectedCreator === '_pira__' && (
            <FormItemContainer>
              <SectionHeader>{t.アイコン画像}</SectionHeader>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
              />
            </FormItemContainer>
          )}
          <FormItemContainer>
            <SectionHeader>{t.なまえ}</SectionHeader>
            <InputText {...register('name', { maxLength: 20 })} />
          </FormItemContainer>
          <FormItemContainer>
            <SectionHeader>{t.性別}</SectionHeader>
            <SexSelector val={selectedSex} onChange={onChangeSex} />
          </FormItemContainer>
          <FormItemContainer>
            <SectionHeader>{t.ID}</SectionHeader>
            <InputText {...register('id', { maxLength: 20 })} />
          </FormItemContainer>
          {selectedCreator === 'MHR_Qoo' && (
            <FormItemContainer>
              <SectionHeader>{'イカ派？タコ派？'}</SectionHeader>
              <TextSelector
                values={SPLATOON_CHAR_TYPES}
                onChange={onChangeChars}
              />
            </FormItemContainer>
          )}
          <FormItemContainer>
            <SectionHeader>{t.ボイスチャット}</SectionHeader>
            <VoiceChatSelector
              onChange={onChangeVoiceChat}
              value={selectedVoiceChat}
              activeValue={
                selectedCreator === 'koharubiyori_51'
                  ? [3, 1, 4]
                  : selectedCreator === 'sakiika10_game'
                  ? [3, 1, 0, 5]
                  : selectedCreator === 'MHR_Qoo'
                  ? [3, 1, 0, 5, 7]
                  : selectedCreator === 'ibless0316'
                  ? [5, 0, 1, 8, 3, 4, 100]
                  : selectedCreator === 'MHR_Qoo_2'
                  ? [3, 1, 0, 5, 7]
                  : selectedCreator === '_pira__'
                  ? [3, 5, 1, 100, 4]
                  : [3, 1, 4]
              }
            />
          </FormItemContainer>
          {selectedCreator === 'sakiika10_game' && (
            <FormItemContainer>
              <SectionHeader>{t.ボイスチャットその他}</SectionHeader>
              <InputText {...register('voiceChatFree', { maxLength: 20 })} />
            </FormItemContainer>
          )}
          {selectedCreator !== 'MHR_Qoo_2' && (
            <FormItemContainer>
              <SectionHeader>{t.プレイ時間帯平日}</SectionHeader>
              <InputSelector {...register('playTimeWeekDayBegin')}>
                <OptionsPlaytime />
              </InputSelector>
              <TimeSelectorText>{t.から}</TimeSelectorText>
              <InputSelector {...register('playTimeWeekDayEnd')}>
                <OptionsPlaytime />
              </InputSelector>
            </FormItemContainer>
          )}
          {selectedCreator !== 'MHR_Qoo_2' && (
            <FormItemContainer>
              <SectionHeader>{t.プレイ時間帯土日}</SectionHeader>
              <InputSelector {...register('playTimeWeekEndBegin')}>
                <OptionsPlaytime />
              </InputSelector>
              <TimeSelectorText>{t.から}</TimeSelectorText>
              <InputSelector {...register('playTimeWeekEndEnd')}>
                <OptionsPlaytime />
              </InputSelector>
            </FormItemContainer>
          )}
          {selectedCreator !== 'MHR_Qoo' &&
            selectedCreator !== 'MHR_Qoo_2' &&
            selectedCreator !== '_pira__' &&
            selectedCreator !== 'MHR_Qoo_3' && (
              <FormItemContainer>
                <SectionHeader>{t.チーム}</SectionHeader>
                <InputText {...register('team', { maxLength: 20 })} />
              </FormItemContainer>
            )}
          {selectedCreator !== 'MHR_Qoo_3' && (
            <FormItemContainer>
              <SectionHeader>{t.ランク}</SectionHeader>
              <InputText type="number" step="1" {...register('rank')} />
            </FormItemContainer>
          )}
          {selectedCreator !== 'MHR_Qoo_2' &&
            selectedCreator !== 'MHR_Qoo_3' && (
              <FormItemContainer>
                <SectionHeader>{t.プレイスタイル}</SectionHeader>
                <InputSelector {...register('playStyle')}>
                  <option value="">未選択</option>
                  <option value="beginner">初心者</option>
                  <option value="serious">ガチ</option>
                  <option value="enjoy">エンジョイ</option>
                </InputSelector>
              </FormItemContainer>
            )}
          {(selectedCreator === 'sakiika10_game' ||
            selectedCreator === 'MHR_Qoo' ||
            selectedCreator === 'ibless0316' ||
            selectedCreator === 'MHR_Qoo_2' ||
            selectedCreator === '_pira__' ||
            selectedCreator === 'MHR_Qoo_3') && (
            <FormItemContainer>
              <SectionHeader>{'好きなルール'}</SectionHeader>
              <TextSelector
                values={SPLATOON_RULES[selectedCreator]}
                onChange={onChangeRules}
              />
            </FormItemContainer>
          )}
          {selectedCreator === 'MHR_Qoo' && (
            <FormItemContainer>
              <SectionHeader>{'フェス'}</SectionHeader>
              <InputText {...register('fes', { maxLength: 20 })} />
            </FormItemContainer>
          )}
          {selectedCreator !== 'MHR_Qoo_2' &&
            selectedCreator !== '_pira__' &&
            selectedCreator !== 'MHR_Qoo_3' && (
              <FormItemContainer>
                <SectionHeader>{'エリア'}</SectionHeader>
                <InputSelector {...register('area')}>
                  <option value="C-">C-</option>
                  <option value="C">C</option>
                  <option value="C+">C+</option>
                  <option value="B-">B-</option>
                  <option value="B">B</option>
                  <option value="B+">B+</option>
                  <option value="A-">A-</option>
                  <option value="A">A</option>
                  <option value="A+">A+</option>
                  <option value="S-">S-</option>
                  <option value="S">S</option>
                  <option value="S+">S+</option>
                </InputSelector>
              </FormItemContainer>
            )}
          {selectedCreator !== 'MHR_Qoo_2' &&
            selectedCreator !== '_pira__' &&
            selectedCreator !== 'MHR_Qoo_3' && (
              <FormItemContainer>
                <SectionHeader>{'ヤグラ'}</SectionHeader>
                <InputSelector {...register('yagura')}>
                  <option value="C-">C-</option>
                  <option value="C">C</option>
                  <option value="C+">C+</option>
                  <option value="B-">B-</option>
                  <option value="B">B</option>
                  <option value="B+">B+</option>
                  <option value="A-">A-</option>
                  <option value="A">A</option>
                  <option value="A+">A+</option>
                  <option value="S-">S-</option>
                  <option value="S">S</option>
                  <option value="S+">S+</option>
                </InputSelector>
              </FormItemContainer>
            )}
          {selectedCreator !== 'MHR_Qoo_2' &&
            selectedCreator !== '_pira__' &&
            selectedCreator !== 'MHR_Qoo_3' && (
              <FormItemContainer>
                <SectionHeader>{'ホコ'}</SectionHeader>
                <InputSelector {...register('hoko')}>
                  <option value="C-">C-</option>
                  <option value="C">C</option>
                  <option value="C+">C+</option>
                  <option value="B-">B-</option>
                  <option value="B">B</option>
                  <option value="B+">B+</option>
                  <option value="A-">A-</option>
                  <option value="A">A</option>
                  <option value="A+">A+</option>
                  <option value="S-">S-</option>
                  <option value="S">S</option>
                  <option value="S+">S+</option>
                </InputSelector>
              </FormItemContainer>
            )}
          {selectedCreator !== 'MHR_Qoo_2' &&
            selectedCreator !== '_pira__' &&
            selectedCreator !== 'MHR_Qoo_3' && (
              <FormItemContainer>
                <SectionHeader>{'アサリ'}</SectionHeader>
                <InputSelector {...register('asari')}>
                  <option value="C-">C-</option>
                  <option value="C">C</option>
                  <option value="C+">C+</option>
                  <option value="B-">B-</option>
                  <option value="B">B</option>
                  <option value="B+">B+</option>
                  <option value="A-">A-</option>
                  <option value="A">A</option>
                  <option value="A+">A+</option>
                  <option value="S-">S-</option>
                  <option value="S">S</option>
                  <option value="S+">S+</option>
                </InputSelector>
              </FormItemContainer>
            )}
          {selectedCreator === 'ibless0316' && (
            <FormItemContainer>
              <SectionHeader>{'サモラン'}</SectionHeader>
              <InputSelector {...register('salmonRun')}>
                <option value="C-">C-</option>
                <option value="C">C</option>
                <option value="C+">C+</option>
                <option value="B-">B-</option>
                <option value="B">B</option>
                <option value="B+">B+</option>
                <option value="A-">A-</option>
                <option value="A">A</option>
                <option value="A+">A+</option>
                <option value="S-">S-</option>
                <option value="S">S</option>
                <option value="S+">S+</option>
              </InputSelector>
            </FormItemContainer>
          )}
          {selectedCreator !== '_pira__' && (
            <FormItemContainer>
              <SectionHeader>{t.好きなブキ}</SectionHeader>
              <InputText {...register('favoriteWeapon', { maxLength: 100 })} />
            </FormItemContainer>
          )}
          {(selectedCreator === 'MHR_Qoo_2' ||
            selectedCreator === '_pira__' ||
            selectedCreator === 'MHR_Qoo_3') && (
            <FormItemContainer>
              <SectionHeader>{'ウデマエ'}</SectionHeader>
              <InputText {...register('udemae', { maxLength: 100 })} />
            </FormItemContainer>
          )}
          {selectedCreator === '_pira__' && (
            <FormItemContainer>
              <SectionHeader>{'バイト'}</SectionHeader>
              <InputText {...register('baito', { maxLength: 100 })} />
            </FormItemContainer>
          )}
          <FormItemContainer>
            <SectionHeader>{t.ひとこと}</SectionHeader>
            <InputText {...register('hitokoto', { maxLength: 50 })} />
          </FormItemContainer>
          <ButtonDescriptionText>
            {t.カードの作成にはSNS連携が必要です次の画面でログインをします}
          </ButtonDescriptionText>
          <Submit
            id="create_profile"
            type="submit"
            value={t.これでつくる}
            disabled={submitButtonDisable}
          />
        </form>
      </FormContainer>
    </>
  )
}

const PreviewContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
`

const PreviewCardContainer = styled.div`
  background-color: ${colors.bg.primary};
  box-shadow: 0 0 4px rgba(32, 32, 32, 0.1);
`

const FormContainer = styled.div`
  padding: 20px;
`

const FormItemContainer = styled.div`
  margin-bottom: 32px;
`

const DescriptionSection = styled.div`
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 30px;
`

const Time = styled.div`
  color: ${colors.text.secondary};
  font-size: 12px;
`

const H1Text = styled.h1`
  margin-top: 12px;
  font-size: 18px;
  font-weight: bold;
  line-height: 20px;
  color: ${colors.text.primary};
  text-align: center;
  line-height: 1.6;
  display: flex;
`

const H2Text = styled.h2`
  margin-top: 20px;
  font-size: 13px;
  color: ${colors.text.secondary};
  line-height: 1.6;
  display: flex;
`

const SectionHeader = styled.div`
  margin-top: 20px;
  margin-bottom: 16px;
  font-weight: bold;
  font-size: 18px;
  color: ${colors.text.primary};
  display: flex;
`

const TimeSelectorText = styled.div`
  margin: 8px auto;
  color: ${colors.text.primary};
  font-size: 12px;
  font-weight: bold;
`

const ButtonDescriptionText = styled.h3`
  margin: auto;
  margin-top: 30px;
  width: 100%;
  font-size: 10px;
  color: ${colors.text.secondary};
  justify-content: center;
  display: flex;
`

const Submit = styled.input`
  margin-top: 12px;
  border-radius: 20px;
  border: 3px solid transparent;
  width: 100%;
  height: 40px;
  background-color: ${colors.button.primary};
  color: #fff;
  font-weight: bold;
  display: block;
`
